import { Fragment, lazy, useMemo } from 'react';
import { useLocation } from 'react-use';

import { useColorMode } from 'app/utils/colorMode';
import { AnalyticsError } from 'app/views/layout/views/analytics/components/error/analyticsError';
import { useAppSelector } from 'utils/redux/useAppSelector';

import { useIntelligenceEvents } from './utils/events/useIntelligenceEvents';
import { loadIntelligenceRemote } from './utils/loadIntelligenceRemote';

const IntelligenceRemoteComponent = (): JSX.Element => {
  const location = useLocation();
  const { settings } = useAppSelector((state) => state.analytics);

  const { effectiveColorMode } = useColorMode();

  useIntelligenceEvents();

  const state = useMemo((): string => {
    return btoa(
      JSON.stringify({
        colorMode: effectiveColorMode,
        timezone: settings.timezone,
      }),
    );
  }, [effectiveColorMode, settings.timezone]);

  return location.pathname ? (
    <ng-bi data-state={state} location={location.pathname + location.search} />
  ) : (
    <Fragment />
  );
};

export const IntelligenceRemote = lazy(async () => {
  const success = await loadIntelligenceRemote();

  return {
    default: success ? IntelligenceRemoteComponent : AnalyticsError,
  };
});
